// 🔒
import { Link } from "react-router";
const logo = new URL("../assets/logo.webp", import.meta.url).href;

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="footer">
      <div className="container footer__inner">
        <div className="footer__brandBlock">
          <Link to="" className="brand footer__brand">
            <img src={logo} alt="ELEFIT logo" className="footer__logo" />
            <span>EleFit App</span>
          </Link>

          <p className="footer__tagline">Elevate your fitness.</p>

          <p className="footer__text">
            A premium fitness experience designed to help you train smarter,
            stay consistent, and achieve more with confidence.
          </p>
        </div>

        <div className="footer__right">
          <nav className="footer__nav" aria-label="Footer navigation">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/faq">FAQ</Link>
          </nav>

          <div className="footer__socials">
            <a
              href="https://instagram.com/elefit.app"
              target="_blank"
              rel="noreferrer"
              aria-label="Visit our Instagram"
              className="footer__socialLink"
            >
              <svg
                viewBox="0 0 24 24"
                aria-hidden="true"
                className="footer__socialIcon"
              >
                <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5A3.5 3.5 0 1 0 12 15.5 3.5 3.5 0 0 0 12 8.5Zm5.38-2.62a1.12 1.12 0 1 1 0 2.24 1.12 1.12 0 0 1 0-2.24Z" />
              </svg>
              <span>Instagram</span>
            </a>
          </div>

          <p className="footer__credit">
            Developed by{" "}
            <a
              href="https://www.jupitersro.com"
              target="_blank"
              rel="noreferrer"
            >
              Jupiter s.r.o.
            </a>
          </p>
        </div>
      </div>

      <div className="container footer__bottom">
        <p>© {currentYear} Elefit Software s.r.o. All rights reserved.</p>
      </div>
    </footer>
  );
}
// 🔒